import React, { useState, useEffect, useRef } from 'react';
import TR from '../../Trans';
import Stack from '@mui/material/Stack';
import ArrowButton from '../items/ArrowButton';
import Box from '@mui/material/Box';

function HorizontalContainer(props) {

  const scrollerRef = useRef(null);
  const itemsRef = useRef(null);
  const [scrollerLeft, setScrollerLeft] = useState(0);
  const [isRightShown, setIsRightShown] = useState(true);

  useEffect(() => { 
    if (scrollerRef.current && itemsRef.current) {
      if (itemsRef.current.offsetWidth > 0) {
        if (scrollerLeft + scrollerRef.current.offsetWidth < itemsRef.current.offsetWidth) {
          setIsRightShown(true);
        } else {
          setIsRightShown(false);
        }
      }
    }
  }, [scrollerRef, itemsRef]);

  const renderLeftSide = () => { 
    if (scrollerLeft > 0) {
      return <ArrowButton className="muvika-list-left-arrow-button" isLeft={true} onScrollClick={handleLeftScroll} />;
    }
  };

  const renderRightSide = () => { 
    if (isRightShown) {
      return <ArrowButton className="muvika-list-right-arrow-button" onScrollClick={handleRightScroll} />;
    }
  };

  const handlerScrolling = () => { 
    if (scrollerRef) {
      if (scrollerRef.current) {
        setScrollerLeft(scrollerRef.current.scrollLeft);
      }
    }
  };

  const handleLeftScroll = () => { 
    if (scrollerRef) {
      if (scrollerRef.current) {
        setIsRightShown(true);
        scrollerRef.current.scrollBy({
          top: 0,
          left: -scrollerRef.current.offsetWidth,
          behavior: 'smooth'
        });
      }
    }
  };

  const handleRightScroll = () => { 
    if (scrollerRef.current && itemsRef.current) {
      if (scrollerLeft + scrollerRef.current.offsetWidth < itemsRef.current.offsetWidth) {
        setIsRightShown(true);
        if (scrollerLeft + (2 * scrollerRef.current.offsetWidth) >= itemsRef.current.offsetWidth) {
          setIsRightShown(false);
        }
        scrollerRef.current.scrollBy({
          top: 0,
          left: scrollerRef.current.offsetWidth,
          behavior: 'smooth'
        });
      } else {
        setIsRightShown(false);
      }
    }
  };

  return (
    <div style={{ width: "100%", position: "relative" }}>
      {renderLeftSide()}
      {renderRightSide()}
      <Box ref={scrollerRef} onScroll={handlerScrolling} style={{ width: "100%", overflowX: "scroll", scrollbarWidth: "none", background: "var(--bg-color)" }}>
        <div ref={itemsRef} style={{ width: props.minWidth + "px" }}>
          <Stack direction="row" spacing={0} alignItems="flex-start">
            {props.children}
          </Stack>
        </div>
      </Box>
    </div>
  );
}

export default HorizontalContainer;